import { render } from "./reference.vue?vue&type=template&id=3d8e62a4&scoped=true"
import script from "./reference.vue?vue&type=script&lang=js"
export * from "./reference.vue?vue&type=script&lang=js"

import "./reference.vue?vue&type=style&index=0&id=3d8e62a4&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8e62a4"]])

export default __exports__